import type React from 'react';
import { styled } from '@mui/material/styles';

interface MessageContainerProps {
  children?: React.ReactNode;
  className?: string;
}

const MessageContainer = ({
  children,
  className = '',
}: MessageContainerProps) => {
  return (
    <Wrapper className={className}>
      <ChildrenContainer>{children}</ChildrenContainer>
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;

  &:not(.has-link) + & {
    margin-top: -12px;
  }
`;

const ChildrenContainer = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

export default MessageContainer;
